import {
  TransmissionStatus,
} from '../models/unit-transmission-status';
function getDataTransmissionStates(): TransmissionStatus[] {
  let transmissionConditios: TransmissionStatus[] = [
    {
      transmissionStatusTag: 'inMotion',
      transmissionStatusName: 'En movimiento',
      transmissionUnitCondition: (T) =>
        T.hasIgnition &&
        T.currentSpeed >= 3 &&
        T.elapsedTime < 300 &&
        T.device.satelliteCount > 0,
      transmissionStatusDescription: 'En movimiento',
      transmissionStatusColor: '#18cf18',
      transmissionIsActive: false,
      transmissionStatusId: 1,
    },
    {
      transmissionStatusTag: 'idleWithIgnitionOn',
      transmissionStatusName: 'Detenidas con ignición',
      transmissionUnitCondition: (T) => T.hasIgnition && T.currentSpeed < 3 && T.device.satelliteCount > 0 && T.elapsedTime < 300 && T.elapsedTime > 0,
      transmissionStatusDescription: 'Detenidas con ignición',
      transmissionStatusColor: '#149ae3',
      transmissionIsActive: false,
      transmissionStatusId: 2,
    },
    {
      transmissionStatusTag: 'idleWithoutIgnition',
      transmissionStatusName: 'Detenidas sin ignición',
      transmissionUnitCondition: (T) =>
        !T.hasIgnition &&
        T.elapsedTime < 7200 &&
        T.currentSpeed < 3 &&
        T.device.satelliteCount > 0,
      transmissionStatusDescription: 'Detenidas sin ignición',
      transmissionStatusColor: '#b23ccf',
      transmissionIsActive: false,
      transmissionStatusId: 3,
    },
    {
      transmissionStatusTag: 'noTransmission',
      transmissionStatusName: 'Sin transmisión',
      transmissionUnitCondition: (T) => T.elapsedTime >= 7200,
      transmissionStatusDescription: 'Sin transmisión',
      transmissionStatusColor: '#3d3d3d',
      transmissionIsActive: false,
      transmissionStatusId: 4,
    },
    {
      transmissionStatusTag: 'noSignalCoverage',
      transmissionStatusName: 'Sin cobertura',
      transmissionUnitCondition: (T) =>
        T.hasIgnition &&
        T.currentSpeed >= 3 &&
        T.elapsedTime >= 300 &&
        T.device.satelliteCount > 0,
      transmissionStatusDescription: 'Sin cobertura',
      transmissionStatusColor: '#fa8c15',
      transmissionIsActive: false,
      transmissionStatusId: 5,
    },
    {
      transmissionStatusTag: 'gpsError',
      transmissionStatusName: 'Con error de GPS',
      transmissionUnitCondition: (T) =>
        T.device.satelliteCount === 0 ||
        (T.currentSpeed >= 3 && (!T.hasIgnition || T.batteryVoltage < 5)),
      transmissionStatusDescription: 'Con error de GPS',
      transmissionStatusColor: '#e11414',
      transmissionIsActive: false,
      transmissionStatusId: 6,
    },
    {
      transmissionStatusTag: 'undefined',
      transmissionStatusName: 'No definidas',
      transmissionUnitCondition: (T) => true,
      transmissionStatusDescription: 'No definidas',
      transmissionStatusColor: '#999999',
      transmissionIsActive: false,
      transmissionStatusId: 0,
    },
  ];
  return transmissionConditios;
}

export {
  getDataTransmissionStates,
}